export default {"src":"/_next/static/media/mobility.c7dd3b9a.svg","height":63,"width":66,"blurWidth":0,"blurHeight":0};